import styled from 'styled-components';
import appTheme from '../../themes/Theme';
import { Link } from 'react-router-dom';

export const StyledWrapper = styled.div`
  color: ${appTheme.textColor};
  background-color: ${appTheme.backgroundColor};
  padding-bottom: 32px;
`;

export const StyledFlexContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledLink = styled(Link)`
  color: #25c2a0;
  font-weight: 500;
  text-decoration: none;
`;

export const StyledHyperLink = styled.a`
  color: #25c2a0;
  font-weight: 500;
  text-decoration: none;
`;